import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

export default function SetELODialog({
  openState,
  userContext,
  onClose,
  onSetElo,
}) {
  if ("row" in userContext) {
    const defaultEloFigure = userContext.row.elo || 1000;
    const [elo, setElo] = useState(defaultEloFigure);
    const [btnDisabled, setBtnDisabled] = useState(false);

    const rating3Current = userContext.row.rating3?.current ?? null;
    const rating3Peak = userContext.row.rating3?.peak ?? null;
    const rating3Matches = userContext.row.rating3?.matchesRated ?? 0;

    const impactRatingCurrent = userContext.row.impactRating?.current ?? null;
    const impactRatingPeak = userContext.row.impactRating?.peak ?? null;
    const impactRatingMatches = userContext.row.impactRating?.matchesRated ?? 0;

    return (
      <div>
        {"row" in userContext && (
          <Dialog
            open={openState}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Set {userContext.row.nickname}'s ELO
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please set the numeric ELO value for the user{" "}
                <strong>{userContext.row.nickname}</strong> and click save
                changes to apply the change
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                onChange={(e) => {
                  setElo(e.target.value);
                }}
                value={elo}
                id="elo"
                label="ELO"
                type="number"
                fullWidth
              />

              {/* Rating 3.0 Info (read-only) */}
              <div style={{ marginTop: 16, padding: "12px", backgroundColor: "#f5f5f5", borderRadius: 8 }}>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4 }}>
                  Rating 3.0
                </Typography>
                <Typography variant="body2">
                  Current: {rating3Current != null ? rating3Current.toFixed(2) : "N/A"}
                </Typography>
                <Typography variant="body2">
                  Peak: {rating3Peak != null ? rating3Peak.toFixed(2) : "N/A"}
                </Typography>
                <Typography variant="body2">
                  Matches Rated: {rating3Matches}
                </Typography>
              </div>

              {/* Impact Rating Info (read-only) */}
              <div style={{ marginTop: 12, padding: "12px", backgroundColor: "#f5f5f5", borderRadius: 8 }}>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4 }}>
                  Impact Rating
                </Typography>
                <Typography variant="body2">
                  Current: {impactRatingCurrent != null ? impactRatingCurrent.toFixed(2) : "N/A"}
                </Typography>
                <Typography variant="body2">
                  Peak: {impactRatingPeak != null ? impactRatingPeak.toFixed(2) : "N/A"}
                </Typography>
                <Typography variant="body2">
                  Matches Rated: {impactRatingMatches}
                </Typography>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="primary">
                Dismiss
              </Button>
              <Button
                disabled={btnDisabled}
                onClick={() => {
                  setBtnDisabled(true);
                  onSetElo(elo, userContext.row.userId);
                  setTimeout(() => {
                    setBtnDisabled(false);
                  }, 5 * 1000);
                }}
                color="primary"
              >
                Save Changes
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    );
  }

  return <></>;
}
